import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { FilterContext } from "@/pages/dashboard/components/PageContainer/context";
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';

export default function FunnelStepCardService(props: any) {
  const { style, className, type, config, children, data: propsData, ...resetProps } = props || {};
  const { api} = config || {};
  const  { filterVal } = useContext(FilterContext);

  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
  }), shallowEqual);

  const data = useMemo(() => ({
    gameCode,
    ...(propsData || {})
  }), [gameCode, propsData]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={'funnelCardList'}
        beforeRequest={(data) => {
          const { filterVal, gameCode } = data;
          const params = {
            game_code: gameCode,
            filters: formatFilterValues(filterVal),
          };
          return params;
        } }
        trackData={['gameCode']} 
        config={config}      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            filterVal,
            ...resetProps,
          }
        ))}
      </Service>
    </div>
  );
};